import React, { ReactNode, useState } from 'react'
import {
  PlanFeaturesTableStyled,
  MobileHeaderStyled,
  FeaturesContainerStyled,
} from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesTable.styled'
import { PlanFeaturesSection } from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesSection/PlanFeaturesSection'
import { PlanFeaturesButtons } from 'Features/pricing/components/PlanFeaturesTable/PlanFeaturesButtons/PlanFeaturesButtons'
import { isMobile } from 'react-device-detect'
import { StyledHeader, TabsPricing } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { CSS } from '@stitches/react'

export type TableSection = {
  title: string
  cells: Array<ReactNode | string>
  tooltip: string
  featureNameCss?: CSS
  cellCss?: CSS
}

type TableType = {
  [key: string]: Array<TableSection>
}
type PlanFeaturesTableProps = {
  data: TableType | undefined | void
  selectPlan?: (type: string, billingCycleMonths: number) => void
  exceededMaxVisits?: boolean
  reactivation?: boolean
  billingCycleMonths?: number
}

type Tab = {
  id: number
  title: string
  pageName?: string
  icon?: React.ReactNode
  page: React.ReactNode | null
}

export const PlanFeaturesTable = ({
  data,
  selectPlan,
  exceededMaxVisits,
  reactivation,
  billingCycleMonths,
}: PlanFeaturesTableProps) => {
  const { t } = useTranslation('pricing')
  const [planToShow, setPlanToShow] = useState<number>(0)
  const tabs: Array<Tab> = [
    {
      id: 0,
      title: t('paid_marketing.core'),
      page: null,
      pageName: 'paidMarketing',
    },
    {
      id: 1,
      title: t('paid_marketing.advanced'),
      page: null,
      pageName: 'paidMarketingAdvanced',
    },
    {
      id: 2,
      title: t('paid_marketing.enterprise'),
      page: null,
      pageName: 'paidMarketingEnterprise',
    },
  ]
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0])

  const tabChanged = (tab: Tab) => {
    setActiveTab(tab)
    setPlanToShow(tab.id)
  }

  return (
    <PlanFeaturesTableStyled>
      {!isMobile && selectPlan && (
        <PlanFeaturesButtons
          reactivation={reactivation}
          billingCycleMonths={billingCycleMonths}
          exceededMaxVisits={exceededMaxVisits || false}
          selectPlan={(tab) => {
            selectPlan(tab, billingCycleMonths || 12)
          }}
        />
      )}
      {isMobile && (
        <MobileHeaderStyled>
          <StyledHeader css={{ paddingInline: '$28', paddingBlock: '$24', textAlign: 'center' }}>
            {t('compare')}
          </StyledHeader>
          <TabsPricing tabs={tabs} activeTab={activeTab} onClick={(tab) => tabChanged(tab)} />
        </MobileHeaderStyled>
      )}
      <FeaturesContainerStyled>
        <PlanFeaturesSection
          css={{ marginTop: isMobile ? '0px' : '' }}
          title={t('account')}
          data={data?.['account']}
          planToShow={isMobile ? planToShow : -1}
        />
        <PlanFeaturesSection
          title={t('protection')}
          data={data?.['protection']}
          planToShow={isMobile ? planToShow : -1}
        />
        <PlanFeaturesSection
          title={t('reporting')}
          data={data?.['reporting']}
          planToShow={isMobile ? planToShow : -1}
        />
        <PlanFeaturesSection
          title={t('service')}
          data={data?.['service']}
          planToShow={isMobile ? planToShow : -1}
        />
      </FeaturesContainerStyled>
    </PlanFeaturesTableStyled>
  )
}
